import { Gauge, UserX, Timer, UserCheck, Shuffle, Gem } from 'lucide-react';

const ITEMS = [
  {
    Icon: Gauge,
    title: 'We start with your data, not your UI',
    body: 'Most dashboard designers focus on how it looks. We focus on how fast it runs. In our experience, most slow dashboards are slow because of the queries behind them, not the design. We find the bottleneck and fix it at the source.',
    punch: 'You save months, and often tens of thousands.',
  },
  {
    Icon: UserX,
    title: 'Freelancers disappear',
    body: 'A freelancer builds your dashboard and moves on. Six months later your data changes, the dashboard breaks, and there\u2019s no one left to call.',
    punch: 'We stand behind our work. If something breaks, fixing it is on us.',
  },
  {
    Icon: Timer,
    title: 'Big firms move slowly',
    body: 'A 16-week discovery phase. Junior analysts doing the work. Project managers relaying your words back to you. Four months and $200K later, you finally have a dashboard.',
    punch: 'We deliver in 4 to 6 weeks, and you work directly with the person who builds it.',
  },
  {
    Icon: UserCheck,
    title: 'You get direct access',
    body: 'No sales engineer. No account manager. The person writing your SQL is the person you hired, and the same person stays with you the whole way.',
    punch: null,
  },
  {
    Icon: Shuffle,
    title: 'We adapt to your business',
    body: 'Healthcare reporting works differently from retail, and retail works differently from government. We build for what you actually need, not for what fits a template.',
    punch: null,
  },
  {
    Icon: Gem,
    title: 'Boutique by design',
    body: 'Staying small keeps us fast, focused, and efficient, without the overhead. It also means we recognize when you\u2019d be better served by a larger firm. When that\u2019s the case, we\u2019ll tell you.',
    punch: null,
  },
];

export const WhyPniel = () => (
  <section className="section why" id="why-pniel">
    <div className="container">
      <div className="heading">
        <p className="eyebrow eyebrow-light">Why Pniel</p>
        <h2>Why Pniel, not a freelancer or a big firm?</h2>
        <p>The honest middle ground. Senior expertise, without the disappearing act or the six-figure invoice.</p>
      </div>

      <div className="why-grid">
        {ITEMS.map((item) => (
          <article className="why-card" key={item.title} data-testid={`why-card-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`}>
            <div className="why-icon"><item.Icon className="w-5 h-5" /></div>
            <h3>{item.title}</h3>
            <p>{item.body}</p>
            {item.punch && <p className="why-punch">{item.punch}</p>}
          </article>
        ))}
      </div>
    </div>
  </section>
);
